// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__2VYKu","modal":"Modal_modal__24s0X"};